import React from "react";
import ReactDOM, { createRoot, hydrateRoot } from "react-dom/client";
import { hydrate } from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// const rootElement = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
// root.render(
//     // <React.StrictMode>
//     <App />
//     // </React.StrictMode>
// );

const rootElement = document.getElementById("root");

if (!rootElement) {
    throw new Error("Root element not found");
}

// 정적으로 프리렌더된 HTML이 있는 경우 (e.g., react-snap)
if (rootElement.hasChildNodes()) {
    hydrateRoot(rootElement, <App />);
} else {
    createRoot(rootElement).render(<App />);
}

reportWebVitals();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
